export enum FilterTypesEnum {
    Search = "Search",
    FromDate = "FromDate",
    ToDate = "ToDate",
    Environment = "Environment",
    Platform = "Platform",
    Severity = "Severity",
    ViolationCategory = "Category",
    BusinessCriticality = "Business Criticality",
    SecurityRisk = "Security Risk",
    Integration = "Integration",
    Playbook = "Playbook",
    ResourceCategory = "Resource Category",
    ResourceType = "Type",
    Exempted = "Exempted",
    ViolationStatus = "Violation Status",
    ViolationStatusReason = "Violation Status Reason",
    ResourceStatus = "Resource Status",
    Policy = "Policy",
    LastModifiedSinceDate = "Last Modified Since",
    CreationTimeSinceDate = "Creation Time Since",
    IdentityIsExternal = "Identity Is External",
    allBuilders = "All Builders",
    ConnectionConnectorType = "Connection Connector Type",
    ConnectionInUse = "Connection In Use",
    AutomationUsesAiModel = "Automation Uses AI Model",
    AutomationUsesWebhook = "Automation uses a webhook",
    AutomationUsesHttpStepsWithoutAuthentication = "Automation uses http step without authentication",
    AutomationIsBotTrigger = "Automation is a bot trigger",
    Owasp = "OWASP LCNC",
    OwaspLlm = "OWASP LLM",
    Attack = "MITRE ATT&CK",
    RelatedResource = "Related Resource",
    ConnectorCategory = "Connector Category",
    PolicyType = "Policy Type",
    ViolationRule = "Violation Rule",
    CreatedBy = "Created By",
    OwnedBy = "Owned By",
    PlaybookStatus = "Playbook Status",
    ViolationRuleStatus = "Violation Rule Status",
    ExecutionStatus = "Execution Status",
    LastExecutionSince = "Last Execution Since",
    LastExecutionUntil = "Last Execution Until",
    Role = "Role",
    EnvironmentType = "EnvironmentType",
    BotType = "BotType",
    Department = "Department",
    Label = "Label",
    RuleTag = "Rule Tag",
    GenerativeAiOptions = "Gen-AI",
    PublicAccess = "Public Access",
    OrgWideAccess = "Org Wide Access",
    StepType = "Type",
    Actor = "Actor",
    ThreadId = "Thread Id",
    FindingSeverity = "Finding Severity",
    GenAiMatrix = "GenAI Matrix",
    ClientApplication = "Client Application",
    AiService = "AI Service",
    AIAgentName = "Agent",
}
